import Joi from 'joi'
import errorsResolver from '../schemeUtils'

const clientVisaScheme = Joi.object({
    index: Joi.any(),
    country: Joi.alternatives().conditional(Joi.object(),{
        then: Joi.object({
            label: Joi.string()
                .required('')
                .error(errorsResolver({
                    required: `Страна обязательное поле`
                })),
            value: Joi.number()
                .error(errorsResolver({
                    number: `Должно быть число`
                }))
        })
            .invalid(null)
            .required()
            .error(errorsResolver({
                invalid: `Страна обязательное поле`,
                required: `Страна обязательное поле`
            })),
        otherwise: Joi.string()
            .required()
            .invalid(null)
            .error(errorsResolver({
                invalid: `Страна обязательное поле`,
                required: `Страна обязательное поле`
            }))
    }),
    startDate: Joi.date()
        .required()
        .iso()
        .error(errorsResolver({
            dateFormat: `Некорректная дата начала`
        })),
    endDate: Joi.date()
        .iso()
        .required()
        .greater(Joi.ref("startDate"))
        .error(errorsResolver({
            dateFormat: `Некорректная дата окончания`,
            dateGreater: `Срок окончания должен быть больше даты начала`
        })),
})

export default clientVisaScheme
